import React, { useEffect, useState } from "react";
import { SearchApplicant } from "../../templates/SearchApplicant";
import {
  resetApplicantsState,
  searchApplicantRequest,
} from "../../../redux/applicant/actions";
import { clearSpecificRequest } from "../../../redux/request/action";
import { SEARCH_APPLICANT_REQUEST } from "../../../redux/applicant/actionTypes";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { setPhaseStatus } from "../../../utils/helpers/strings";

const SearchApplicantPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [applicantName, setApplicantName] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const request = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[SEARCH_APPLICANT_REQUEST],
  );

  useEffect(() => {
    if (request?.response?.keyword) {
      setHasSearched(true);
    }
    setApplicantName(request?.response?.keyword);
  }, []);

  useEffect(() => {
    dispatch(resetApplicantsState());
  }, []);

  const handleOnChange = (e: any) => {
    if (e.target.value === '') {
      setHasSearched(false);
      dispatch(clearSpecificRequest(SEARCH_APPLICANT_REQUEST));
    }

    setApplicantName(e.target.value);
  };

  const onClickApplicant = (record: any) => {
    return history.push(
      `/recruit/${
        record.status === "New Applicant"
          ? "new-applicants"
          : setPhaseStatus(record.status)
      }/${record.key}/true`,
      {
        fromSearch: true,
      }
    );
  };

  const handlePressEnter = () => {
    if (applicantName !== "") {
      setHasSearched(true);
      let lowerApplicantName = applicantName.toLocaleLowerCase();
      dispatch(
        searchApplicantRequest(undefined, [["nameKeywords", "array-contains", lowerApplicantName]])
      );
    }
  };

  return (
    <SearchApplicant
      onPressEnter={handlePressEnter}
      applicants={request?.response?.applicants || []}
      onChange={handleOnChange}
      hasSearched={hasSearched}
      isLoading={request?.isLoading}
      onClickApplicant={onClickApplicant}
      applicantName={applicantName}
    />
  );
};

export default SearchApplicantPage;
